module.exports = __webpack_public_path__ + "img/18-3 RedteaGO App for iPhone eSIM _en.8c98497b.png";